import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { useCallback, useContext } from 'react';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Job } from '~hooks/useJob/models';
import { Load, LoadCycle } from '~hooks/useLoad/models';
import LoadStatusTransitioner from '~pages/Dispatch/components/LoadStatusTransitioner';
import { minutesToHoursMins } from '~utils/dateTime';

import LoadsQueryContext from '../../JobsTable/ExpandedBlock/LoadsQueryContext';

interface StatusAndCycleColumnProps {
  cycles: LoadCycle[];
  load: Load;
  job: Job;
  sx?: SxProps<Theme>;
}

export default function StatusAndCycleColumn({
  cycles,
  load,
  job,
  sx,
}: StatusAndCycleColumnProps) {
  const loadsQuery = useContext(LoadsQueryContext);

  const cycleTime =
    cycles.find((cycle) => cycle.fromLoadId === load.id)?.timeMinutes ?? 0;

  const handleLoadUpdate = useCallback(
    (load: Load) => {
      loadsQuery.updateStoredLoadById(load.id, load);
    },
    [loadsQuery],
  );

  return (
    <Box sx={sx}>
      <Box>
        <LoadStatusTransitioner
          jobState={job.status}
          load={load}
          onLoadUpdate={handleLoadUpdate}
        />
      </Box>

      <OverflowAwareText>
        {cycleTime > 0 ? minutesToHoursMins(cycleTime) : '-'}
      </OverflowAwareText>
    </Box>
  );
}
